/**
 * Build-time configuration. Vite only exposes `VITE_`-prefixed variables to the
 * browser bundle, so every runtime setting must use that prefix.
 */
export const isProduction = import.meta.env.PROD;

export const apiBaseUrl =
  import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:4000';

export const graphqlUri =
  import.meta.env.VITE_GRAPHQL_URI ?? `${apiBaseUrl}/graphql`;
